module.exports = __webpack_public_path__ + "static/img/about_logo.68ca206c.png";